<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title"> Plus Editor
                    <span class="tag is-warning">  {{idlab}}</span>
                    <span class="tag is-info is-light" v-if="submitTypePlusEdit === 'ct' ">  {{findingAndContentPlus}}</span>
                    <span class="tag is-info is-light" v-if="submitTypePlusEdit === 'prepare' ">  {{headerInfoPreparePlus}}</span>
                    </p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
<TemplateLoadStatus :detail-loading="templateDetailLoading" :detail-error="templateDetailError" @retry-detail="retryTemplateDetail" />


                <nav class="level is-mobile">
                    <div class="level-left">

                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <p class="is-size-6 has-text-grey"> My Templates </p>
                        </div>
                        <div class="level-item">

                            <b-select placeholder="Template" v-model="dataTemplateSelected"  >
                                <option
                                        v-for="dataTemplate in templateCatalogue"
                                        :value="dataTemplate.id"
                                        :key="dataTemplate.id">
                                    {{ dataTemplate.title }}
                                </option>
                            </b-select>


                        </div>
                        <div class="level-item">
                            <b-button type="is-success"
                                      icon-right="plus"
                                      @click="addTemplate"
                                     />
                        </div>
                    </div>
                </nav>


                <vue-editor v-model="dataEditor"
                            id="editorDat_prepare"
                            ref="editorDat_prepare"
                            :editor-toolbar="customToolbar"

                />
            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveBtn" >Save </b-button>

            </footer>
        </div>
    </div>
</template>

<script>
import templateCatalogue from '@/mixins/templateCatalogue'
    import { VueEditor } from "vue2-editor"
    import globalconst from "../../../mixins/globalconst";
    import htmlToText from "html-to-text";
    import {mapState} from "vuex";
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios   } from '@/utils.js'


    export default {
        name: "PlusEditor",
        mixins:[templateCatalogue,globalconst],
        components:{
            VueEditor
        },
        props:{
           idlab : String,
           labKind : String,
           isShowing : Boolean,
           submitTypePlusEdit : String
        },
        computed :{
            ...mapState({
                 clientIP : state => state.master_data.clientIP,
                 user_id : state => state.master_data.user_id,
                 myTemplate : state => state.mytemplateTxt.myTemplate,
                 access_token: state => state.master_data.access_token,
            }) ,
            getTextFromContentHTML:function () {
                return  htmlToText.fromString( this.dataEditor, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            }
        },
        // watch:{
        //     isShowing:{
        //         immediate : true,
        //         handler: function (val) {
        //             if(val){
        //                 console.log('is show')
        //             }
        //         }
        //     }
        // },
        methods:{
            addTemplate(editorTarget) { return this.insertCachedTemplate(editorTarget) },
            closeBtn(){
                // console.log('closeBtn')
                this.$emit("close")

            },
            saveBtn(){

                // console.log('save btn')
                // if(this.submitTypePlusEdit === this.SUBMIT_TYPE_PLUS_EDIT.prepare){
                //     console.log('pre pare')
                // }else{
                //     console.log('ct naja')
                // }
                var tmpSection = -1
                this.submitTypePlusEdit === this.SUBMIT_TYPE_PLUS_EDIT.prepare
                ?
                    tmpSection    = 1  // backend know for  1 = prepare 2 = ct
                :
                    tmpSection    = 2 // backend know for  1 = prepare 2 = ct


                var tmpTbl = -1
                if(this.labKind.toUpperCase() ===  "CYTOLOGY"){
                    tmpTbl    = 1  // backend know for  tbl  1 = cyto , 2 = biopsy , 3 = PCR  ,4 = Bacterial , 5 = ORGANISM
                }else if(this.labKind.toUpperCase() ===  "BIOPSY"){
                    tmpTbl    = 2  // backend know for  tbl  1 = cyto , 2 = biopsy , 3 = PCR  ,4 = Bacterial , 5 = ORGANISM
                }else if(this.labKind.toUpperCase() ===  "PCR"){
                    tmpTbl    = 3  // backend know for  tbl  1 = cyto , 2 = biopsy , 3 = PCR  ,4 = Bacterial , 5 = ORGANISM
                }else if(this.labKind.toUpperCase() ===  "BACTERIAL"){
                    tmpTbl    = 4  // backend know for  tbl  1 = cyto , 2 = biopsy , 3 = PCR  ,4 = Bacterial , 5 = ORGANISM
                }else if(this.labKind.toUpperCase() ===  "ORGANISM"){
                    tmpTbl    = 5 // backend know for  tbl  1 = cyto , 2 = biopsy , 3 = PCR  ,4 = Bacterial  , 5 = ORGANISM
                }else if(this.labKind.toUpperCase() ===  "NECROPSY"){
                    tmpTbl    = 6 // backend know for  tbl  1 = cyto , 2 = biopsy , 3 = PCR  ,4 = Bacterial  , 5 = ORGANISM , 6 = Necropsy
                }else if(this.labKind.toUpperCase() ===  "PARASITE"){
                    tmpTbl    = 7 // backend know for  tbl  1 = cyto , 2 = biopsy , 3 = PCR  ,4 = Bacterial  , 5 = ORGANISM , 6 = Necropsy
                }
                // this.labKind.toUpperCase() ===  "CYTOLOGY"
                //     ?
                //     tmpTbl    = 1  // backend know for  tbl  1 = cyto , 2 = biopsy
                //     :
                //     tmpTbl    = 2 // backend know for  tbl  1 = cyto , 2 = biopsy

                const datTo = {
                               idlab : this.idlab ,
                               // if BACTERIAL or PCR ==> encode to base64
                               // ct    : this.labKind.toUpperCase() ===  "PCR" || this.labKind.toUpperCase() ===  "BACTERIAL" ?   Buffer.from(this.dataEditor).toString('base64')    : this.dataEditor,
                               // txt   : this.labKind.toUpperCase() ===  "PCR" || this.labKind.toUpperCase() ===  "BACTERIAL" ?   Buffer.from(this.getTextFromContentHTML).toString('base64')    : this.getTextFromContentHTML,
                               ct    :    Buffer.from(this.dataEditor).toString('base64')  ,
                               txt   :    Buffer.from(this.getTextFromContentHTML).toString('base64')   ,
                               ip    : this.clientIP,
                               tbl   : tmpTbl,
                               sections : tmpSection
                              }



                // console.log(JSON.stringify(datTo))
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/newinsertprepareandctplus `,datTo,getConfigAxios())
                    .then(()=>{
                        vm.$buefy.toast.open({
                            message: 'Update data completely!',
                            type: 'is-success'
                        })
                    })
                    .catch(err=>{

                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}` ,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })
                this.$emit("closeWithChange")
            }
        },
        data(){
            return{
                dataEditor : "",
                dataTemplateSelected : null,
                // dataTemplates: null,
            }
        }
    }
</script>

<style scoped>

</style>